import { Component, OnInit, Inject,AfterViewInit,ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA  } from '@angular/material';
import { DoctorService } from '../services/doctor.service';
@Component({
  selector: 'app-doctorchatrequest',
  templateUrl: './doctorchatrequest.component.html',
  styleUrls: ['./doctorchatrequest.component.css']
})
export class DoctorchatrequestComponent implements OnInit,AfterViewInit {
reqid: any;
flag = 0;
timer: any;
counter = 50;
@ViewChild("audio") audio;
@ViewChild("audio2") audio2;
 x: any;
 y: any;
 r: any;
  constructor(public DialogRef: MatDialogRef<DoctorchatrequestComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private doctorService: DoctorService) { 
      this.reqid = data.reqid;
      this.timer = setInterval(() => this.continueSession(), 1000);

    }

  ngOnInit() {
    
  }
ngAfterViewInit(){
  /*this.audio.nativeElement.oncanplaythrough = () => {
    this.audio.nativeElement.play();
  };*/
  this.x = document.getElementById("audio"); 
  this.x.play();
  this.y  = document.getElementById("audio2"); 
}
continueSession(){
  this.counter = this.counter-1;
  console.log(this.flag)
  if(this.counter == 4 && this.flag == 0){
    this.y.play();
  }
  if(this.counter == 0 || this.flag == 1) {
    clearInterval(this.timer);
    this.sessionOver();
  }
}
sessionOver(){
  console.log('in session over');
  this.DialogRef.close(this.r);
}
acceptRequest(){
const status = 'Accepted';
this.doctorService.AcceptChatRequest(this.reqid, status)
.subscribe((x)=>{
  this.r = 1;
  this.flag = 1;
});
}
rejectRequest(){
const status = 'Rejected';
this.doctorService.AcceptChatRequest(this.reqid, status)
.subscribe((x) => {
      this.r = 2;
      this.flag = 1;
});
}

}
